import { IonGrid, IonRow, IonCol, IonButton, IonContent, IonList, IonDatetime, IonItem, IonInput, IonText } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import '../../../css/layout.css';

import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import { AddExpenseModal } from './Modal_AddExpense';
import { ViewExpensesModal } from './Modal_ViewExpenses';
import { DailyCashDepositModal } from './Modal_DailyCashDeposit';
//import { ViewDepositApprovalsModal } from './Modal_ViewDepositApprovals';
import { ViewDepositsModal } from './Modal_ViewDeposits';
import { AddProjectModal } from '../../../zInternal_Features/merchant/components/Modal_AddProject';
import { ViewProjectsModal } from '../../../zInternal_Features/merchant/components/Modal_ViewProjects';
//import { View_MTNAPI } from './Modal_View_MTNAPI';

export function OverviewBusinessSlides(props) {

    //alert('In OverviewBusinessSlides');
    //alert(authenticatedMerchent_context.startDate);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);
    //authenticatedMerchent_context.changeStartDateRange(new Date(new Date().setDate(new Date().getDate()-30)));
    //authenticatedMerchent_context.changeEndDateRange(new Date(new Date().setDate(new Date().getDate()+30)));
    //alert('In OverviewBusinessSlides')
    //alert(authenticatedMerchent_context.acctID);
    //alert(authenticatedMerchent_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    const [userRole, setUserRole] = useState(authenticatedMerchent_context.accessRights[0]);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    //let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate()-30)));
    //let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+30)));


    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate() - 5)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 1)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);


    let [newCheckInModal, setNewCheckInModal] = useState(false);
    let [openAddExpenseModal, setAddExpenseModal] = useState(false);
    let [openAddExpense_projectionModal, setAddExpense_projectionModal] = useState(false);

    let [openViewExpenseModal, setViewExpensesModal] = useState(false);
    let [openViewExpenses_projectionModal, setViewExpenses_projectionModal] = useState(false);

    let [openViewPaidDepositsModal, setViewPaidDepositsModal] = useState(false);

    let [totalSales, setTotalSales] = useState(0);
    let [projectedRevenue, setProjectedRevenue] = useState(0);
    let [totalExpense, setTotalExpense] = useState(0);
    let [totalExpense_projection, setTotalExpense_projection] = useState(0);
    let [profits, setProfits] = useState(0);
    let [cashDepositAmount, setCashDepositAmount] = useState(0);

    let [numRoomsAvailable, setNumRoomsAvailable] = useState(0);
    let [numRoomsOccupied, setNumRoomsOccupied] = useState(null);
    let [numRoomsBooked, setNumRoomsBooked] = useState(null);
    let [numRoomsNeedCleaning, setNumRoomsNeedCleaning] = useState(null);
    
    let [showAvailableRoomsModal, setShowAvailableRoomsModal] = useState(false);
    let [showDailyDepositModal, setShowDailyDepositModal] = useState(false);

    let [showDepositApprovalsModal, setShowDepositApprovalsModal] = useState(false);

    let [dailyDeposit_send, setDailyDeposit_send] = useState('inline-block');
    let [dailyDeposit_pendindApproval, setDailyDeposit_pendingApproval] = useState('none');

    let [total_projects, setTotalProjects] = useState();
    let [addProjectModal, setAddProjectsModal] = useState(false);
    let [viewProjectModal, setViewProjectsModal] = useState(false);
    //let [openMTNAPI_Modal, setOpenMTNAPI_MODAL] = useState(false);

 
    function reloadDates(event)
    {

         //alert('In Tab Overview UseEffect');
        //alert(authenticatedMerchent_context.accessRights[0]);
        // alert(JSON.parse(authenticatedMerchent_context.feature).employeeHR);
        // alert(JSON.parse(authenticatedMerchent_context.feature).jobs);

        //alert(startDate);
        //alert(endDate);

        let formData = new FormData();
        let tracker = 0;

        if(userRole == 'admin')
        {
            formData.append('Tracker', 74001);
            tracker = "74001_retail";

        }
        else if(userRole == 'manager')
        {
            formData.append('Tracker', 74002);
            tracker = "74002_retail";

        }
        //formData.append('Tracker', 74001);
        /*formData.append('user', acctID);
        formData.append('xStartDateRange', startDate.toISOString().substr(0, 10));
        formData.append('xEndDateRange', endDate.toISOString().substr(0, 10));


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //let rows = res.toString().split('~~~');
            //let rowLength = rows.length;

                //for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                //{
                    //let cols = rows[rownum].split('|');

                    if(authenticatedMerchent_context.accessRights[0] == 'admin')
                    {
                        let cols = res.toString().split('|');

                        setTotalSales(parseFloat(cols[0]).toFixed(2));
                        setTotalExpense(parseFloat(cols[3]).toFixed(2));
                       // setTotalExpense_projection(parseFloat(cols[4]).toFixed(2));
                        setCashDepositAmount(parseFloat(cols[4]).toFixed(2));
                        setTotalProjects(cols[5]);

                    }
                    
                    if(authenticatedMerchent_context.accessRights[0] == 'manager')
                    {
                        let rows = res.toString().split('~~~');
                        let cols1 = rows[0].split('|');
                        let cols2 = rows[1].split('|');

                        //setTotalSales(parseFloat(cols1[0]).toFixed(2));
                        setTotalExpense(parseFloat(cols1[3]).toFixed(2));
                       // setTotalExpense_projection(parseFloat(cols[4]).toFixed(2));
                        //setCashDepositAmount(parseFloat(cols1[4]).toFixed(2));
                        setTotalProjects(cols1[5]);


                        if(cols2[5] == "P")
                        {
                            setDailyDeposit_send('none');
                            setDailyDeposit_pendingApproval('inline-block');
                        }
                        else
                        {
                            setDailyDeposit_send('inline-block');
                            setDailyDeposit_pendingApproval('none');
                        }
            
                    }

                       
                    authenticatedMerchent_context.changeStartDateRange(event[0]);
                    authenticatedMerchent_context.changeEndDateRange(event[1]);

            })

    }

    useEffect(() => {

        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);

       //alert('In Tab Overview');
       //alert(authenticatedMerchent_context.accessRights[0]);
        //alert(authenticatedMerchent_context.startDate);
        //alert(authenticatedMerchent_context.endDate);
        //alert(authenticatedMerchent_context.accessRights);
        //alert(authenticatedMerchent_context.accessRights[0]);

        //alert(startDate);
        //alert(startDate.toUTCString());
        //alert(startDate.getDate());
       // alert(startDate.getUTCDate());

        //alert(viewProjectModal);

        //alert("In Tab_Overview");
        //alert(authenticatedMerchent_context.accessRights[0]);
        //alert(authenticatedMerchent_context.device);

        return (

            <React.Fragment>

            <IonItem className='ion_dateInput'>
                <IonGrid>
                        <DateRange setDate={(e) => reloadDates(e)} data={{
                        startDate: startDate, 
                        endDate: endDate
                        }}></DateRange>
                </IonGrid>
            </IonItem>
            
            <IonContent className='appContent'>
            {
                authenticatedMerchent_context.accessRights[0] == 'admin' && 

                <IonGrid >
                    <IonRow>
                        <IonCol size='6'>
                            <h3>Sales</h3>
                            <p > {totalSales} </p>
                        </IonCol>
                        <IonCol size='6'>
                            <h3>Cash</h3>
                            <p > {cashDepositAmount} </p>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3>Expenses</h3>
                            <p > {totalExpense} </p>
                            <IonButton onClick={() => setAddExpenseModal(true)}> Add </IonButton>
                            <IonButton onClick={() => setViewExpensesModal(true)}> View </IonButton>
                        </IonCol>
                        <IonCol size='6'>
                            <h3>Projects</h3>
                            <p > {total_projects} </p>
                            <IonButton onClick={() => setAddProjectsModal(true)}> Add  </IonButton>
                            <IonButton onClick={() => setViewProjectsModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3> Check-Out </h3>
                            <p > {cashDepositAmount} </p>
                            <IonButton onClick={() => setViewPaidDepositsModal(true)}> View </IonButton>
                        </IonCol>
                        {/*<IonCol size='6'>
                            <h3> MTN </h3>
                            <IonButton onClick={() => setOpenMTNAPI_MODAL(true)}> View </IonButton>
                            </IonCol>*/}
                    </IonRow>
                </IonGrid>

            }

            {
                authenticatedMerchent_context.accessRights[0] == 'manager' &&
                <IonGrid >
                    <IonRow>
                        <IonCol size='6'>
                            <h3>Sales</h3>
                            <p > {totalSales} </p>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3>Expenses</h3>
                            <p > {totalExpense} </p>
                            <IonButton onClick={() => setAddExpenseModal(true)}> Add </IonButton>
                            <IonButton onClick={() => setViewExpensesModal(true)}> View </IonButton>
                        </IonCol>
                        <IonCol size='6'>
                            <h3>Projects</h3>
                            <p > {total_projects} </p>
                            <IonButton onClick={() => setAddProjectsModal(true)}> Add  </IonButton>
                            <IonButton onClick={() => setViewProjectsModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <h3> Check-Out </h3>
                            <p > {cashDepositAmount} </p>
                            <IonButton onClick={() => setViewPaidDepositsModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    {/*<IonRow>
                        <IonCol size='6'>
                            <h3> Daily Cash Deposit </h3>
                            <p > {cashDepositAmount} </p>
                            <IonButton onClick={() => setViewPaidDepositsModal(true)}> View </IonButton>
                            <IonButton style={{display: dailyDeposit_send}} onClick={() => setShowDailyDepositModal(true)}> Submit </IonButton>
                            <IonButton style={{display: dailyDeposit_pendindApproval}} > Pending Approval </IonButton>
                        </IonCol>
                        </IonRow>*/}
                </IonGrid>

            }

            {showDailyDepositModal == true && <DailyCashDepositModal openModal={ showDailyDepositModal } closeModal={() => setShowDailyDepositModal(false)} depositAmount={cashDepositAmount}></DailyCashDepositModal>}


            {openAddExpenseModal == true && <AddExpenseModal openModal={ openAddExpenseModal }  closeModal={() => setAddExpenseModal(false)} ></AddExpenseModal>}
            {openViewExpenseModal == true && <ViewExpensesModal openModal={ openViewExpenseModal }  closeModal={() => setViewExpensesModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewExpensesModal>}

            {addProjectModal == true && <AddProjectModal openModal={ addProjectModal }  closeModal={() => setAddProjectsModal(false)} ></AddProjectModal>}
            {viewProjectModal == true && <ViewProjectsModal openModal={ viewProjectModal }  closeModal={() => setViewProjectsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewProjectsModal>}

            {openViewPaidDepositsModal == true && <ViewDepositsModal openModal={ openViewPaidDepositsModal }  closeModal={() => setViewPaidDepositsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewDepositsModal>}

            {/*{openMTNAPI_Modal == true &&  <View_MTNAPI openModal={ openMTNAPI_Modal }  closeModal={() => setOpenMTNAPI_MODAL(false)}></View_MTNAPI>}*/}


            </IonContent>

            </React.Fragment>

        )
    //}   
}